<template>
    <div class="my-servers-container">
        <sidebar
            :sidebar-dashboard="true"
            class="my-servers-container__sidebar"
        ></sidebar>
        <sidebar-mobile
            class="my-servers-container__sidebar-mobile"
        ></sidebar-mobile>
        <creator-name class="my-servers-container__creator-name"></creator-name>
        <my-servers-head
            class="my-servers-container__my-servers"
        ></my-servers-head>
        <summary-table
            class="my-servers-container__summary-table"
        ></summary-table>
        <summary-detail
            class="my-servers-container__summary-detail"
        ></summary-detail>
        <by-games class="my-servers-container__by-games"></by-games>
    </div>
</template>

<script>
import Sidebar from '@/components/sidebar/index';
import SidebarMobile from '@/components/sidebar_mobile/index';
import CreatorName from '@/components/dashboard/sections/DashboardCreatorName';
import MyServersHead from '@/components/my_servers/sections/MyServersHead';
import SummaryTable from '@/components/my_servers/sections/SummaryTable';
import SummaryDetail from '@/components/my_servers/sections/SummaryDetail';
import { mapActions } from 'vuex';

export default {
    name: 'MyServers',
    components: {
        Sidebar,
        SidebarMobile,
        CreatorName,
        MyServersHead,
        SummaryTable,
        SummaryDetail,
        ByGames: () => import('@/components/my_servers/sections/ByGames'),
    },
    created: function() {
        this.fetchServers();
    },
    methods: {
        ...mapActions('module_servers', ['fetchServers']),
    },
};
</script>

<style scoped lang="scss">
.my-servers-container {
    @include main-grid-container;

    &__sidebar {
        grid-column: col-start / span 3;
        grid-row: auto;
        height: 100%;
    }
    &__sidebar-mobile {
        grid-column: col-start / span 13;
        grid-row: auto;
    }
    &__creator-name {
        grid-column: col-start 4 / 13;
        grid-row: 1;
        @media (max-width: $xm-up) {
            grid-column: col-start / 13;
            margin-top: 3rem;
        }
    }
    &__my-servers {
        margin-top: -800px;
        grid-column: col-start 4 / 13;
        grid-row: 2;
        background: $white-main;
        height: $smallest-height;
        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin-top: 4rem;
        }
    }
    &__summary-table {
        margin-top: -520px;
        grid-column: col-start 4 / 13;
        grid-row: 3;
        background: $white-main;
        height: $very-small-height;
        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin-top: 0;
        }
    }
    &__summary-detail {
        margin-top: -70px;
        grid-column: col-start 4 / 13;
        grid-row: 4;
        background: $white-main;
        height: $very-small-height;
        @media (max-width: $xl-up) {
            margin-top: -30px;
        }
        @media (min-width: $xs-up) and (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin: 0 auto 12rem auto;
            height: 450px;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            height: $medium-height;
            margin: 1rem auto 0 0;
            grid-column: col-start / 13;
        }
    }
    &__by-games {
        grid-column: col-start 4 / 13;
        grid-row: 5;
        background: $white-main;
        height: auto;
        @media (max-width: $xl-up) {
            margin-top: 120px;
        }
        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin-top: 0;
        }
    }
}
</style>
